import { ITableStructure, TableContainer, useAppDispatch } from '../../../base';
import { TableIds } from '../../../common';
import { useTableCells } from './hooks/useTableCells';
import { useTableFilters } from './hooks/useTableFilters';
import { useTableCallbacks } from './hooks/useTableCallbacks';
import { useBulkActions } from './hooks/useBulkActions';
import { useTableToggles } from './hooks/useTableToggles';
import { useEffectOnce } from 'react-use';
import { jobsActions } from '../../../actions';

interface Props {
    isSavedForLater?: boolean;
}

const JobApplicationsTable = ({ isSavedForLater = false }: Props) => {
    const dispatch = useAppDispatch();
    const cells = useTableCells();
    const filters = useTableFilters();
    const bulkActions = useBulkActions();
    const toggles = useTableToggles();
    const { onRowClick, onMenuItemClick, onIsSavedButtonClick } =
        useTableCallbacks(isSavedForLater);

    useEffectOnce(() => {
        dispatch(jobsActions.fetchAssignedJobList());
    });

    const callbacks = {
        onRowClick,
        onMenuItemClick,
        onButtonClick: onIsSavedButtonClick,
    };

    const tableStructure: ITableStructure = {
        id: isSavedForLater
            ? TableIds.SAVED_FOR_LATER
            : TableIds.JOB_APPLICATIONS,
        cells,
        filters,
        bulkActions,
        toggles,
        rowSelection: true,
    };

    return <TableContainer structure={tableStructure} callbacks={callbacks} />;
};

export default JobApplicationsTable;
